<template functional>
  <v-dialog :value="props.shown"
            @input="listeners.close && listeners.close($event)"
            scrollable
            lazy
            max-width="600px"
            :persistent="props.persistent">
    <v-card>
      <v-card-title class="headline">
        <v-icon v-if="props.icon" medium class="mr-2">{{ props.icon }}</v-icon>
        {{ props.title }}
        <v-layout justify-end>
          <v-icon @click="listeners.close && listeners.close($event)" right>close</v-icon>
        </v-layout>
      </v-card-title>

      <v-card-text>
        <slot></slot>
      </v-card-text>

      <v-card-actions>
        <slot name="actions"></slot>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'nx-simple-dialog',
  props: {
    title: String,
    shown: Boolean,
    persistent: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
    },
  },
};
</script>
